import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const client = axios.create({ baseURL: API });

// attach admin token if present
client.interceptors.request.use((config) => {
  const token = localStorage.getItem("hogtide_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const api = {
  // public
  createLead: (data) => client.post("/leads", { ...data, referrer: sessionStorage.getItem("ht_referrer") ?? document.referrer }).then((r) => r.data),
  track: (path) => {
    let sid = sessionStorage.getItem("ht_sid");
    if (!sid) {
      sid = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
      sessionStorage.setItem("ht_sid", sid);
    }
    const landing = !sessionStorage.getItem("ht_landed");
    if (landing) {
      sessionStorage.setItem("ht_landed", "1");
      sessionStorage.setItem("ht_referrer", document.referrer || "");
    }
    return client.post("/analytics/track", { path, referrer: document.referrer, event: "pageview", sid, landing }).catch(() => {});
  },
  getBlog: () => client.get("/blog").then((r) => r.data),
  getPost: (slug) => client.get(`/blog/${slug}`).then((r) => r.data),
  getConfig: () => client.get("/config").then((r) => r.data),
  // admin
  login: (email, password) => client.post("/admin/login", { email, password }).then((r) => r.data),
  changePassword: (current_password, new_password) => client.post("/admin/change-password", { current_password, new_password }).then((r) => r.data),
  getTemplates: () => client.get("/admin/templates").then((r) => r.data),
  saveTemplates: (templates) => client.put("/admin/templates", { templates }).then((r) => r.data),
  me: () => client.get("/admin/me").then((r) => r.data),
  adminLeads: (status) => client.get(`/admin/leads${status ? `?status=${status}` : ""}`).then((r) => r.data),
  leadsRecent: (since) => client.get(`/admin/leads/recent${since ? `?since=${encodeURIComponent(since)}` : ""}`).then((r) => r.data),
  getLead: (id) => client.get(`/admin/leads/${id}`).then((r) => r.data),
  pushPublicKey: () => client.get("/push/public-key").then((r) => r.data),
  pushSubscribe: (sub) => client.post("/push/subscribe", sub).then((r) => r.data),
  pushTest: () => client.post("/push/test").then((r) => r.data),
  updateLead: (id, status) => client.patch(`/admin/leads/${id}`, { status }).then((r) => r.data),
  deleteLead: (id) => client.delete(`/admin/leads/${id}`).then((r) => r.data),
  analytics: () => client.get("/admin/analytics/summary").then((r) => r.data),
  traffic: (range = "daily") => client.get(`/admin/analytics/traffic?range=${range}`).then((r) => r.data),
  adminBlog: () => client.get("/admin/blog").then((r) => r.data),
  createPost: (data) => client.post("/admin/blog", data).then((r) => r.data),
  updatePost: (id, data) => client.put(`/admin/blog/${id}`, data).then((r) => r.data),
  deletePost: (id) => client.delete(`/admin/blog/${id}`).then((r) => r.data),
  generatePost: (data) => client.post("/admin/blog/generate", data).then((r) => r.data),
};

export default api;
